import React from 'react';

const STATUS_CONFIG = {
  'Notificada': { label: 'Notificada', className: 'status-notificada' },
  'En espera': { label: 'En espera', className: 'status-espera' },
  'Cancelada': { label: 'Cancelada', className: 'status-cancelada' },
  'Completada': { label: 'Completada', className: 'status-completada' },
};

export function StatusBadge({ status, size = 'sm' }) {
  const config = STATUS_CONFIG[status] || { label: status, className: 'bg-slate-100 text-slate-700' };
  const sizeClass = size === 'lg' ? 'px-4 py-1.5 text-sm' : 'px-2.5 py-0.5 text-xs';
  
  return (
    <span
      data-testid="solicitud-status-badge"
      className={`inline-flex items-center font-semibold rounded-full border ${sizeClass} ${config.className}`}
    >
      {config.label}
    </span>
  );
}

export default StatusBadge;
